import { Directive, HostListener, ElementRef, TemplateRef, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { CalltoactionService } from './calltoaction.service';

@Directive({ selector: '[calltoaction]',standalone: false })
export class CalltoactionDirective implements OnDestroy {
  @Input() calltoactionTemplate: TemplateRef<any>;
  @Input() calltoactionPosition: string = "bottom";
  @Input() calltoactionUsesHover: boolean = false;
  @Input() calltoactionCloseOnOutsideClick: boolean = true;
  @Input() calltoactionMaxWidth: string = '300px';
  @Input() calltoactionUseTruncationParent: boolean = false;
  @Input() calltoactionVerticalOffset: number = 12;
  @Input() calltoactionHorizontalOffset: number = 12;
  @Input() calltoactionKeepWithinBoundary: boolean = false;
  @Output() calltoActionOnShow = new EventEmitter<boolean>();
  @Output() calltoActionOnHide = new EventEmitter<boolean>();

  private id: string;
  active: boolean = false;

  constructor(private ctas: CalltoactionService, private element: ElementRef) {
    this.ctas.getChanges().subscribe((d: any) => {
      if(d === "remove") {
        this.active = false;
      }
    });
  }
  
  @HostListener('mouseenter', ['$event'])
  onMouseEnter(e: Event): void {
    if(this.calltoactionUsesHover) {
      this.create(e);
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    if(this.calltoactionUsesHover) {
      this.destroy();
    }
  }

  @HostListener('click', ['$event'])
  onClick(e: any) {
    if(!this.calltoactionUsesHover) {
      this.create(e);
    }
  }
  
  create(e: any): void {
    this.id = (new Date()).getTime().toString();
    
    if(!this.active && this.calltoactionTemplate !== null) {
      this.destroy();
      this.id = (new Date()).getTime().toString();
      
      const d = { 
        id: this.id, 
        ref: this.element, 
        directive: this,
        template: this.calltoactionTemplate,
        position: this.calltoactionPosition,
        closeOnOutsideClick: this.calltoactionCloseOnOutsideClick,
        maxWidth: this.calltoactionMaxWidth,
        event: e,
        useTruncationParent: this.calltoactionUseTruncationParent,
        verticalOffset: this.calltoactionVerticalOffset,
        horizontalOffset: this.calltoactionHorizontalOffset,
        keepWithinBoundary: this.calltoactionKeepWithinBoundary,
        usesHover: this.calltoactionUsesHover
      };
      
      if(d.template) {
        setTimeout(() => this.ctas.add(d));
        this.active = true;
        this.calltoActionOnShow.emit(true);
      }
    } else {
      this.destroy();
      this.active = false;
      this.calltoActionOnHide.emit(true);
    }
  }
  
  ngOnDestroy(): void {
    this.destroy();
  }

  destroy(): void {
    this.ctas.remove();
  }
}
